export enum AssetTypes {
  TRANSLATIONS = 'translations',
  FEATURE_TOGGLES = 'feature-toggles',
  CONFIGS = 'configs'
}
